import { httpInstance } from '@/services/httpInstance';

const deleteDistributionCenterService = async (promoId) => {
  let res;
  const endpoint = `/delivery/v1/distribution-centers/${promoId}`;

  await httpInstance.delete(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default deleteDistributionCenterService;
